import 'core-js/es6/array';
import '../bootstrap';
import 'jsbarcode';
JsBarcode(".barcode").init();

import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);
window.Swiper = Swiper;

import '../libs/qrcode';
$('.qrcode').each(function() {
  let $this = $(this);
  new QRCode($this.get(0), $this.data('value'));
});

import bugsnag from '@bugsnag/js';
if (process.env.MIX_BUGSNAG_API_KEY) {
  window.bugsnagClient = bugsnag({
    apiKey: process.env.MIX_BUGSNAG_API_KEY,
    autoDetectErrors: false,
  });
}

import feather from 'feather-icons';
window.feather = feather;
feather.replace();

$('[data-toggle="quantity-subtract"]').on('click', function() {
  let $this = $(this);
  let $input = $this.parent().find($this.attr('data-target'));
  $input.val(Math.max(parseInt($input.val()) - 1, 1));
});

$('[data-toggle="quantity-add"]').on('click', function () {
  let $this = $(this);
  let $input = $this.parent().find($this.attr('data-target'));
  $input.val(parseInt($input.val()) + 1);
});

$('[data-toggle="side-menu"]').on('click', function () {
  let $this = $(this);
  $($this.attr('data-target')).toggleClass('active');
});

function readURL(input) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      $('#imagePreview').css('background-image', 'url(' + e.target.result + ')');
      $('#imagePreview').hide();
      $('#imagePreview').fadeIn(650);
    }
    reader.readAsDataURL(input.files[0]);
  }
}
$('[data-toggle="image-preview"]').change(function () {
  let input = this;
  let $target = $($(this).data('target'));

  console.log(input, $target);

  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      $target.html(`
        <div class="card-img">
          <img src="${e.target.result}" class="img-fluid">
        </div>
      `);
    }
    reader.readAsDataURL(input.files[0]);
  }
});

new Swiper('.kv-swiper-container', {
  loop: true,
  autoplay: {
    delay: 3000,
  },

  // If we need pagination
  pagination: {
    el: '.kv-swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.kv-swiper-button-next',
    prevEl: '.kv-swiper-button-prev',
  },
});

new Swiper('.hottest-swiper-container', {
  loop: true,
  // autoplay: {
  //   delay: 3000,
  // },
  slidesPerView: 3,
  spaceBetween: 10,

  // If we need pagination
  pagination: {
    el: '.hottest-swiper-pagination',
  },
});

function updateCounter() {
  $('.online-counter').each(function () {
    let $this = $(this);
    $this.addClass('animated').find('strong').text(parseInt(Math.random() * 50))
    setTimeout(function() {
      $this.removeClass('animated');
    }, 2000);
  });
}

setInterval(function() {
  updateCounter();
}, 5000);

$(function() {
  updateCounter();
});
